export default __webpack_public_path__ + "static/media/AlarmChannel.914dfff5.png";